/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
/** input type for inserting data into table "company_marketing_support" */
export type Company_Marketing_Support_Insert_Input = {
  company_id?: string | null | undefined;
  id?: string | null | undefined;
  support?: Marketing_Support_Enum | null | undefined;
};

export type Marketing_Support_Enum =
  | 'FURNITURE'
  | 'OTHER'
  /** English acronym for 'PLV' */
  | 'POS';

export type UpsertCompanyMarketingSupportsMutationVariables = Exact<{
  companyId: string;
  marketing_supports: Array<Types.Company_Marketing_Support_Insert_Input> | Types.Company_Marketing_Support_Insert_Input;
}>;


export type UpsertCompanyMarketingSupportsMutation = { delete_company_marketing_support: { affected_rows: number } | null, insert_company_marketing_support: { affected_rows: number } | null };


export const UpsertCompanyMarketingSupportsDocument = /*#__PURE__*/ gql`
    mutation upsertCompanyMarketingSupports($companyId: uuid!, $marketing_supports: [company_marketing_support_insert_input!]!) {
  delete_company_marketing_support(where: {company_id: {_eq: $companyId}}) {
    affected_rows
  }
  insert_company_marketing_support(objects: $marketing_supports) {
    affected_rows
  }
}
    `;
export type UpsertCompanyMarketingSupportsMutationFn = Apollo.MutationFunction<UpsertCompanyMarketingSupportsMutation, UpsertCompanyMarketingSupportsMutationVariables>;

/**
 * __useUpsertCompanyMarketingSupportsMutation__
 *
 * To run a mutation, you first call `useUpsertCompanyMarketingSupportsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCompanyMarketingSupportsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCompanyMarketingSupportsMutation, { data, loading, error }] = useUpsertCompanyMarketingSupportsMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      marketing_supports: // value for 'marketing_supports'
 *   },
 * });
 */
export function useUpsertCompanyMarketingSupportsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCompanyMarketingSupportsMutation, UpsertCompanyMarketingSupportsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCompanyMarketingSupportsMutation, UpsertCompanyMarketingSupportsMutationVariables>(UpsertCompanyMarketingSupportsDocument, options);
      }
export type UpsertCompanyMarketingSupportsMutationHookResult = ReturnType<typeof useUpsertCompanyMarketingSupportsMutation>;
export type UpsertCompanyMarketingSupportsMutationResult = Apollo.MutationResult<UpsertCompanyMarketingSupportsMutation>;
export type UpsertCompanyMarketingSupportsMutationOptions = Apollo.BaseMutationOptions<UpsertCompanyMarketingSupportsMutation, UpsertCompanyMarketingSupportsMutationVariables>;